// Phase 7 (rewise-ui) / Phase 8 port: the single place that renders
// exam_questions.provenance into the exact label strings
// rewise_app_design_reference.md's provenance rule requires. Branon must
// never label an AI-generated or reconstructed question as a genuine past
// exam question -- every question shown in the Exam Simulator routes through
// this function rather than any ad-hoc string.

export type Provenance = "genuine_past_paper" | "adapted_pattern" | "ai_generated";

export interface ProvenanceInput {
  provenance: Provenance;
  exam_type?: string | null;
  state_board?: string | null;
  year_level?: number | null;
  source_year?: number | null;
  source_session?: string | null;
  source_question_number?: string | null;
  marks?: number | null;
}

export function buildProvenanceLabel(q: ProvenanceInput): string {
  const board = q.state_board || q.exam_type || "Board";

  if (q.provenance === "genuine_past_paper") {
    return [
      `${board}${q.year_level ? ` Class ${q.year_level}` : ""} Board Examination`,
      q.source_year != null ? String(q.source_year) : null,
      q.source_session,
      q.source_question_number,
      q.marks != null ? `${q.marks} marks` : null,
    ].filter(Boolean).join(" — ");
  }

  if (q.provenance === "adapted_pattern") {
    const suffix = /board/i.test(board) ? "" : " board";
    return `Based on ${board}${suffix} question patterns`;
  }

  return "Branon Practice Question";
}
